import { createFileRoute, redirect } from "@tanstack/react-router"
import { useTranslate } from "src/domains/i18n/use-translate"
import { ErrorPage } from "src/ui/error-page/error-page"
import z from "zod"

const searchSchema = z.object({
  token: z.string(),
})

// Redirect shim: /reset-confirm moved to /password/reset/confirm. Kept so the
// password-reset link in already-sent emails keeps working. The token is
// validated and forwarded so the new page receives it unchanged.
export const Route = createFileRoute("/(redirects)/reset-confirm")({
  component: () => null,
  validateSearch: searchSchema,
  errorComponent: ResetConfirmLinkError,
  beforeLoad: async ({ search }) => {
    throw redirect({
      to: "/password/reset/set-new-password",
      search: { token: search.token },
    })
  },
})

function ResetConfirmLinkError() {
  const { tPlaceholder } = useTranslate()

  return (
    <ErrorPage
      title={tPlaceholder("Invalid reset link")}
      description={tPlaceholder(
        "This password reset link is missing required information. Request a new one from the sign-in page."
      )}
    />
  )
}
